// extracted by mini-css-extract-plugin
export default {"container":"MapTooltip_container__w27er","arrow":"MapTooltip_arrow__nFaq5","text":"MapTooltip_text__bPfXD"};